import { Box, Divider, Skeleton } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectComponentStore } from "../../../system/PageStore";
import { ShortCut } from "../../../system/ShortCut";
import { setLinkGroupRender } from "../../../system/Slicer/HomePageSlicer";
import { MainCardProps } from "../../components/MainCard";
import { DefaultSetting } from "../../defaultSetting";
import { MainCards } from "../MainCards";

export function HomePageUseFullLinkGroup() {
    const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
    const dispatch = useDispatch();
    const componentStates = useSelector(selectComponentStore);
    const navigate = useNavigate();
    const scrollHandler = (_: any) => {
        if (inputRef.current.getBoundingClientRect().top <= DefaultSetting.renderDistance) dispatch(setLinkGroupRender((true)))
    };
    useEffect(() => {
        window.addEventListener("scroll", scrollHandler, true);
        return () => {
            window.removeEventListener("scroll", scrollHandler, true);
        };
    }, []);

    let data: Array<MainCardProps> = [
        {
            key: "Support",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/support2425.jpg",
            onClick: () => ShortCut.windowOpen("https://www.pkps.edu.hk/pdf/2024-2025/support2.pdf")
        },
        {
            key: "star",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/star_button.png",
            onClick: () => ShortCut.windowOpen("https://star.hkedcity.net/zh-hant")
        },
        {
            key: "midStory",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/story_button.png",
            onClick: () => ShortCut.windowOpen("http://www.pkps.edu.hk/newhtml/login/story/story.htm")
        },
        {
            key: "nblib",
            src: "https://play-lh.googleusercontent.com/0nFeAq92cvbWvLS8hLCU6PnPPyEvAOLRXAyfc_aUU2Wd7c0jU68kFVW7bkss2Qg6BBU=w240-h480-rw",
            onClick: () => ShortCut.windowOpen("https://pkps.nblib.com/")
        },
        /*{
            key: "edcity",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/educity_button.png",
            onClick: () => ShortCut.windowOpen("https://www.edcity.hk/home/")
        },*/
        {
            key: "E-smart2.0",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/esmart_button.png",
            onClick: () => ShortCut.windowOpen("https://ebookweb.ephhk.com/login.php")
        },
        {
            key: "Google Classroom",
            src: "https://www.pkps.edu.hk/img/website/homePage/cover/gc_button.png",
            onClick: () => ShortCut.windowOpen("https://accounts.google.com/ServiceLogin?continue=https%3A%2F%2Fclassroom.google.com&passive=true")
        }
    ]

    return (
        <Box ref={inputRef} className="HomePageLinkGroup">
             {
                !componentStates.HomePageComponentReducer.linkGroupRender &&
                <Skeleton height={"200px"} />
            }
            {
                componentStates.HomePageComponentReducer.linkGroupRender &&
                <Box>
                    <Divider>連結</Divider>
                    <MainCards height="85px" justifyContent="space-evenly" alignItems="stretch" imgSx={{ maxWidth: "43vw", minWidth: "180px" }} data={data} />
                </Box>
            }
        </Box>
    )
}